const MIN_RANGE_EXTRA_BARS = 0;
const MAX_RANGE_EXTRA_BARS = 2147483647;

export {
  MIN_RANGE_EXTRA_BARS,
  MAX_RANGE_EXTRA_BARS
};
